import { render, staticRenderFns } from "./difficultyLevels.vue?vue&type=template&id=24df3846"
import script from "./difficultyLevels.vue?vue&type=script&lang=js"
export * from "./difficultyLevels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports